// extracted by mini-css-extract-plugin
export var container = "ProductDetails-module--container--25uxO";
export var title = "ProductDetails-module--title--1vEQp";
export var subtitle = "ProductDetails-module--subtitle--1yOtu";
export var wrapper = "ProductDetails-module--wrapper--2I-ce";
export var table = "ProductDetails-module--table--1ptbE";
export var list = "ProductDetails-module--list--qLoni";
export var withImage = "ProductDetails-module--withImage--2rU7q";
export var item = "ProductDetails-module--item--17x18";
export var decorated = "ProductDetails-module--decorated--3DlUM";